import React, { Component } from 'react'
import { injectIntl, FormattedMessage, FormattedNumber } from 'react-intl'
import PropTypes from 'prop-types'
import Button from '../components/Button'
import FormattedCheckbox from '../components/FormattedCheckbox'
import Utils from '../lib/utils'
import Textbox from '../components/Textbox'
import Dropdown from '../components/Dropdown'

class BookingRentalForm extends Component {

  constructor(props) {
    super(props)
    this.state = {
      info: props.info,
      equipment: props.equipment,
      insurance: props.insurance
    }
    this.onChange          = this.onChange.bind(this)
    this.addRentalToPerson = props.addRentalToPerson.bind(this)
    
    this.keyCount = 0
    this.getKey = this.getKey.bind(this)
  }

  componentDidMount() {
    const { props } = this

    const filteredSkus = props.skus.filter(sku => (
      sku.attributes.hours === props.hoursCount.toString()
      && sku.attributes.ageCategory === props.ageCategory.toLowerCase())
    ).sort((a, b) => (b.price - a.price))
    this.setState({ filteredSkus })
  }

  onChange(e) {
    const {info} = this.state
    this.setState({
      info: {
        ...info,
        [e.target.name]: e.target.value
      }
    })
  }
  
  getKey() {
    this.keyCount += 1
    return this.keyCount
  }

  toggleByName(name, value) {
    const { equipment } = this.state
    equipment[name] = equipment[name] === value ? null : value
    this.setState({ equipment })
  }  

  render() {
    const { props } = this
    const { intl, hoursCount, ageCategory, skus } = props 
    const { equipment, info, insurance, filteredSkus } = this.state

    const submitInfo = () => this.addRentalToPerson(equipment, info, insurance)

    return (
      <div className="sm:pb-8 md:pb-0">
        <div className="mb-4 border-b">
          <h2>
            <FormattedMessage id="booking.person.rental.header" defaultMessage="Rental equipment" />
          </h2>
          {/* <p>
            For smooth expidition upon your arrival
            <br />
            - fill in your needed sizes.
          </p>
          <p>
            <Link to="/" className="underline text-harbor">
              Read more about our rental equipment
            </Link>
          </p> */}
        </div>

        <h4>
          {hoursCount}
          &nbsp;
          <FormattedMessage id='booking.person.rental.hours' default="hours" />
          ,&nbsp;
          {ageCategory && (
            <FormattedMessage id={`booking.person.rental.${ageCategory.toLowerCase()}Size`} default="hours" />
          )}
        </h4>
        <div className="mt-4">
          {filteredSkus && filteredSkus.map(sku => (
            <button
              id={sku.attributes.type}
              name={sku.attributes.type}
              type="button"
              onClick={() => this.toggleByName(sku.attributes.type, sku.id)}
              // valuetrue' ? 'false' : 'true'}
              className="flex text-sm items-center mt-4"
              key={this.getKey()}
            >
              <>
                <FormattedCheckbox checked={!!equipment[sku.attributes.type]} />
                <FormattedMessage id={`booking.person.rental.${sku.attributes.type}`} />
                &nbsp;
                <span className="font-bold">
                  <FormattedNumber
                    minimumFractionDigits={2}
                    value={sku.price / 100}
                  />
                  &nbsp;kr.
                </span>
                
                </>
              {/* <FormattedCheckbox checked={person.insuranceCancellation} />
              <div className="font-bold">
                <FormattedMessage
                  id='booking.person.insuranceCancellation'
                  defaultMessage='Cancellation insurance'
                />
              </div> */}
            </button>            
          ))}
        </div>
        <div className="mt-4 pt-4 border-t md:w-3/4">
          <h4>
            <FormattedMessage
              id="booking.person.rental.personal.header"
              defaultMessage="To make the equipment ready for you when you arrive, please fill out these fields"
            />
          </h4>
          <label htmlFor="skisOrBoard" className="flex items-center mt-4">
            <div className="flex-grow text-sm">
              <FormattedMessage id="booking.person.rental.skisOrBoard" defaultMessage="Skis og snowboard" />
            </div>
            <Dropdown
              htmlId="skisOrBoard"
              htmlName="skisOrBoard"
              onChange={this.onChange}
              // type="number"
              className="w-1/3"
              value={info && info.skisOrBoard}
            >
              <option value="">
                {intl.formatMessage({ id: 'booking.person.rental.select', defaultMessage: 'Select' })}
              </option>              
              <option value="skis">
                {intl.formatMessage({ id: 'booking.person.rental.skis', defaultMessage: 'Skis' })}
              </option>
              <option value="board">
                {intl.formatMessage({ id: 'booking.person.rental.board', defaultMessage: 'Board' })}
              </option>                
              {/* <option value="snowbike">
                {intl.formatMessage({ id: 'booking.person.rental.snowbike', defaultMessage: 'Snowbike' })}
              </option>                 */}
            </Dropdown>
          </label>

          <label htmlFor="footSize" className="flex items-center mt-4">
            <div className="flex-grow text-sm">
              <FormattedMessage id="booking.person.rental.footSize" defaultMessage="Shoe size (EUR)" />
            </div>
            <Textbox
              htmlId="footSize"
              htmlName="footSize"
              onChange={this.onChange}
              type="number"
              className="w-1/3"
              value={info && info.footSize}
            />
          </label>

          <label htmlFor="height" className="flex items-center mt-4">
            <div className="flex-grow text-sm">
              <FormattedMessage id="booking.person.rental.height" defaultMessage="Height in cm" />
            </div>
            <Textbox
              htmlId="height"
              htmlName="height"
              onChange={this.onChange}
              type="number"
              className="w-1/3"
              value={info && info.height}
            />
          </label>

          <label htmlFor="weight" className="flex items-center mt-4">
            <div className="flex-grow text-sm">
              <FormattedMessage id="booking.person.rental.weight" defaultMessage="Weight (kg). To adjust bindings" />
            </div>
            <Textbox
              htmlId="weight"
              htmlName="weight"
              onChange={this.onChange}
              type="number"
              className="w-1/3"
              value={info && info.weight}
            />
          </label>

          {/* <label htmlFor="experience" className="flex items-center mt-4">
            <div className="flex-grow text-sm">
              <FormattedMessage id="booking.person.rental.experience" defaultMessage="Experience (no. of weeks skiing)" />
            </div>
            <Textbox
              htmlId="experience"
              htmlName="experience"
              onChange={this.onChange}
              type="number"
              className="w-1/3"
              value={info && info.experience}
            />
          </label>

          <label htmlFor="head" className="flex items-center mt-4">
            <div className="flex-grow text-sm">
              <FormattedMessage id="booking.person.rental.head" defaultMessage="Head circumference in cm" />
            </div>
            <Textbox
              htmlId="head"
              htmlName="head"
              onChange={this.onChange}
              type="number"
              className="w-1/3"
              value={info && info.head}
            />
          </label> */}
        </div>

        <div className="mt-8 p-4 bg-grey-lighter">
          <button
            id="insurance"
            name="insurance"
            type="button"
            onClick={() => this.setState({ insurance: !insurance })}
            // value={insuranceRental === 'true' ? 'false' : 'true'}
            className="flex text-sm items-center"
          >
            <FormattedCheckbox checked={insurance} />
            <div className="font-bold">
              <FormattedMessage
                id='booking.person.insuranceRental'
                defaultMessage='Rental Insurance'
              />
            </div>
            &nbsp;+
            {props.intl.formatNumber(Utils.getSkuPrice('insurance', 'rentalSkuId', skus), { minimumFractionDigits: 2 })}
            &nbsp;DKK pr.
            {intl.formatMessage({ id: 'booking.person.rental', defaultMessage: 'rental' })}
            .
          </button>
          <div className="text-xs mt-4">
            <FormattedMessage id="booking.person.rental.insurance.desc" defaultMessage="[translate]" />
          </div>
        </div>        

        <Button
          onClick={submitInfo}
          className="mt-8"
          disabled={Utils.objEmpty(equipment)}
        >
          <>{intl.formatMessage({ id: 'booking.person.rental.submit', defaultMessage: 'Update booking' })}</>
        </Button>
      </div>
    )
  }
}


BookingRentalForm.propTypes = {
  equipment: PropTypes.shape({ equipment: PropTypes.object }).isRequired,
  info: PropTypes.shape({ info: PropTypes.object }).isRequired,
  insurance: PropTypes.bool,
  addRentalToPerson: PropTypes.func.isRequired,
  skus: PropTypes.instanceOf(Array).isRequired,
  hoursCount: PropTypes.number.isRequired,
  ageCategory: PropTypes.string.isRequired,
}

BookingRentalForm.defaultProps = {
  insurance: false
}

export default injectIntl(BookingRentalForm)